import type { JSX } from 'react'

import { TopNumber8SC } from './TopNumbers.styled'

export const Top8 = (): JSX.Element => (
  <TopNumber8SC
    width='141'
    height='195'
    viewBox='0 0 141 195'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M70.7722 195C57.1622 195 45.0039 192.653 34.2973 187.958C23.5907 183.264 15.1525 176.764 8.98263 168.458C2.99421 159.972 0 150.403 0 139.75C0 129.278 2.81274 119.979 8.43822 111.854C14.2452 103.729 21.6853 98.0417 30.7587 94.7917C22.4112 92.0833 15.7876 86.6667 10.888 78.5417C5.98842 70.4167 3.53861 61.4792 3.53861 51.7292C3.53861 41.4375 6.35135 32.4097 11.9768 24.6458C17.7838 16.7014 25.7683 10.6528 35.9305 6.5C46.0927 2.16667 57.6158 0 70.5 0C83.3842 0 94.9073 2.16667 105.069 6.5C115.232 10.6528 123.125 16.6111 128.751 24.375C134.558 32.1389 137.461 41.1667 137.461 51.4583C137.461 61.0278 135.012 69.875 130.112 78C125.212 86.125 118.498 91.7222 109.969 94.7917C119.768 98.2222 127.39 104.09 132.834 112.396C138.278 120.521 141 129.639 141 139.75C141 150.403 138.006 159.972 132.017 168.458C126.029 176.764 117.681 183.264 106.975 187.958C96.2684 192.653 84.2008 195 70.7722 195ZM70.7722 81.5208C82.5676 81.5208 91.6409 79.0833 97.9923 74.2083C104.344 69.3333 107.519 62.3819 107.519 53.3542C107.519 44.3264 104.344 37.375 97.9923 32.5C91.6409 27.4444 82.4768 24.9167 70.5 24.9167C58.5232 24.9167 49.3591 27.4444 43.0077 32.5C36.6564 37.375 33.4807 44.3264 33.4807 53.3542C33.4807 62.3819 36.6564 69.3333 43.0077 74.2083C49.5405 79.0833 58.7954 81.5208 70.7722 81.5208ZM70.2278 169.812C83.2934 169.812 93.2741 167.104 100.17 161.688C107.066 156.271 110.514 148.597 110.514 138.667C110.514 128.736 106.975 121.062 99.8977 115.646C93.0019 110.229 83.2027 107.521 70.5 107.521C57.7973 107.521 47.9073 110.229 40.8301 115.646C33.9344 121.062 30.4865 128.736 30.4865 138.667C30.4865 148.778 33.9344 156.542 40.8301 161.958C47.7259 167.194 57.5251 169.812 70.2278 169.812Z'
      fill='url(#paint0_linear_5096_100028)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100028'
        x1='-13.8822'
        y1='3.01302'
        x2='173.377'
        y2='171.797'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber8SC>
)
